import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { Button } from './Button';
const bonuses = [{
  name: 'Calculadora de Rentabilidad (Excel)',
  desc: 'Calculá costos, ganancias y márgenes al instante. Sabé exactamente <strong>cuánto ganás por cada tanda</strong> y nunca más vendas a pérdida.',
  price: 79900,
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&q=80'
}, {
  name: 'Pack de Diseño Marca Profesional',
  desc: 'Plantillas de Canva listas para usar. <strong>Logos, etiquetas y packaging</strong> que venden solos. Tu marca va a parecer de una empresa grande.',
  price: 89000,
  image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=400&q=80'
}, {
  name: 'Guía Anti-Fracasos',
  desc: 'Los <strong>9 errores fatales</strong> que arruinan tu negocio antes de empezar. Evitalos desde el día 1 y ahorrá miles de pesos.',
  price: 59900,
  image: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=400&q=80'
}, {
  name: "Checklist 'Tu Negocio en 7 Días'",
  desc: 'El plan diario para pasar de cero a <strong>pedidos reales en una semana</strong>. Seguí los pasos y empezá a facturar.',
  price: 74000,
  image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=400&q=80'
}, {
  name: 'Guía de Sabores Rentables',
  desc: 'Qué sabores vender primero para <strong>maximizar ganancias</strong>. Los sabores que más piden y los que mejor margen dejan.',
  price: 64000,
  image: 'https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?w=400&q=80'
}, {
  name: 'Kit de Fotos Profesionales',
  desc: 'Fotos listas para usar en <strong>redes sociales y WhatsApp</strong>. Vendé más con imágenes que enamoran a tus clientes.',
  price: 87000,
  image: 'https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=400&q=80'
}, {
  name: 'Pack Estrategia de Ventas',
  desc: '<strong>Guiones de venta, mensajes para WhatsApp</strong> y estrategias probadas para conseguir clientes fijos que te compren todas las semanas.',
  price: 99000,
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80'
}];
const totalValue = bonuses.reduce((sum, b) => sum + b.price, 0);
export function Content() {
  return <section className="pt-0 pb-20 bg-palomitas-cream" data-id="element-34">
      <div className="container px-4 mx-auto max-w-4xl" data-id="element-35">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-36">
          {/* Social Proof Card */}
          <div className="bg-white border-2 border-palomitas-gold rounded-2xl p-8 md:p-10 mb-8 max-w-2xl mx-auto" data-id="element-37">
            <p className="text-4xl md:text-6xl font-serif font-bold text-palomitas-emerald mb-2" data-id="element-38">
              +37.893
            </p>
            <p className="text-xl md:text-2xl font-bold text-palomitas-brown mb-1" data-id="element-39">
              mujeres ya tienen su independencia económica
            </p>
            <p className="text-lg text-gray-500 italic mb-4" data-id="element-40">
              cocinando desde casa.
            </p>
            <div className="flex justify-center gap-1 mb-2" data-id="element-41">
              {[...Array(4)].map((_, i) => <span key={i} className="text-3xl" data-id="element-42">
                  ⭐
                </span>)}
              <span className="text-3xl opacity-60" data-id="element-43">⭐</span>
            </div>
            <p className="text-gray-600 font-medium" data-id="element-44">
              Calificación Promedio:{' '}
              <strong className="text-palomitas-brown" data-id="element-45">4,9/5</strong>
            </p>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-palomitas-brown mb-4" data-id="element-46">
            🎁 Aceleradores de Ganancias{' '}
            <span className="text-palomitas-coral" data-id="element-47">(BONOS GRATIS HOY)</span>
          </h2>
          <div className="w-16 h-1 bg-palomitas-emerald mx-auto mb-6" data-id="element-48"></div>
          <p className="text-xl text-gray-600" data-id="element-49">
            Herramientas exclusivas para{' '}
            <strong className="text-palomitas-brown" data-id="element-50">
              multiplicar tus ventas
            </strong>{' '}
            y diferenciarte.
          </p>
        </motion.div>

        {/* Bonus Cards */}
        <div className="space-y-6" data-id="element-51">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-white rounded-2xl border-2 border-palomitas-gold/40 p-5 md:p-6 flex flex-col sm:flex-row gap-5 items-center shadow-md" data-id="element-52">
              {/* Image */}
              <div className="w-full sm:w-48 flex-shrink-0" data-id="element-53">
                <img src={bono.image} alt={bono.name} className="w-full h-40 sm:h-44 object-cover rounded-xl shadow-sm" data-id="element-54" />
              </div>

              {/* Info */}
              <div className="flex-1" data-id="element-55">
                <h3 className="text-xl md:text-2xl font-bold text-palomitas-brown mb-2" data-id="element-56">
                  🎁 {bono.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed" dangerouslySetInnerHTML={{
              __html: bono.desc
            }} data-id="element-57" />
                <div className="flex items-center gap-3" data-id="element-58">
                  <span className="text-red-500 line-through font-bold text-lg" data-id="element-59">
                    ${bono.price.toLocaleString('es-AR')}
                  </span>
                  <span className="bg-palomitas-emerald/15 text-palomitas-emerald font-bold px-4 py-1.5 rounded-lg border border-palomitas-emerald/30 text-sm uppercase tracking-wide" data-id="element-60">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Total Value Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-12 border-[3px] border-dashed border-palomitas-coral rounded-2xl p-6 md:p-10 text-center" data-id="element-61">
          {/* Módulo Premium Box */}
          <div className="bg-palomitas-emerald/5 border-2 border-dashed border-palomitas-emerald/40 rounded-xl p-6 mb-8 text-left max-w-lg mx-auto" data-id="element-62">
            <p className="text-lg text-palomitas-brown mb-3" data-id="element-63">
              🎁 Y además, solo por hoy, te llevás el{' '}
              <strong data-id="element-64">Módulo Premium</strong>:
            </p>
            <p className="text-gray-700 mb-2" data-id="element-65">
              🚀 <strong data-id="element-66">Cómo usar Mercado Libre y redes sociales</strong> para
              escalar cuando ya estés vendiendo.
            </p>
            <p className="text-gray-700" data-id="element-67">
              📦 Con <strong data-id="element-68">2 módulos extras</strong> y{' '}
              <strong data-id="element-69">2 videos explicativos</strong> paso a paso para{' '}
              <strong data-id="element-70">VENDER EN GRAN VOLUMEN</strong>.
            </p>
          </div>

          <p className="text-2xl md:text-3xl font-serif font-bold text-palomitas-brown mb-6 underline underline-offset-4" data-id="element-71">
            EL VALOR REAL ES INCALCULABLE...
          </p>

          <div className="bg-palomitas-emerald rounded-xl py-3 px-8 inline-block mb-6" data-id="element-72">
            <p className="text-white font-bold text-lg" data-id="element-73">
              Te llevás el Programa Completo + 7 Bonos + Módulo Premium
            </p>
          </div>

          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-74">
            <span className="text-3xl md:text-5xl font-bold text-red-500 line-through" data-id="element-75">
              ${totalValue.toLocaleString('es-AR')}
            </span>
            <span className="bg-palomitas-dark text-white font-bold px-5 py-2 rounded-lg text-lg" data-id="element-76">
              SOLO POR HOY
            </span>
          </div>

          <p className="text-palomitas-emerald font-bold text-xl md:text-2xl mb-8" data-id="element-77">
            GRATIS con tu compra
          </p>

          <Button href="https://cocinaydulcesrentables.com/cart/54079623528732:1" className="w-full sm:w-auto text-xl px-10 py-5 !bg-palomitas-emerald hover:!bg-emerald-500 !text-white shadow-xl" data-id="element-78">
            ¡ASEGURAR MIS BONOS AHORA!
          </Button>
        </motion.div>
      </div>
    </section>;
}